import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // 현재 경로에 따라 활성화 클래스 추가
  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          SAFE<span className="highlight">182</span>
        </Link>

        <div className="menu-icon" onClick={toggleMenu}>
          <i className={menuOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
        </div>

        <ul className={menuOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link to="/" className={`nav-link ${isActive('/')}`} onClick={() => setMenuOpen(false)}>
              홈
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/missing-persons" className={`nav-link ${isActive('/missing-persons')}`} onClick={() => setMenuOpen(false)}>
              실종자 찾기
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/missing-person-registration" className={`nav-link ${isActive('/missing-person-registration')}`} onClick={() => setMenuOpen(false)}>
              메시지 등록
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/disaster-messages" className={`nav-link ${isActive('/disaster-messages')}`} onClick={() => setMenuOpen(false)}>
              재난문자
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/device-control" className={`nav-link ${isActive('/device-control')}`} onClick={() => setMenuOpen(false)}>
              장비 제어
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/weather" className={`nav-link ${isActive('/weather')}`} onClick={() => setMenuOpen(false)}>
              날씨 모니터링
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;